import { formatDistanceToNowStrict } from 'date-fns';

export const GetAgoTime = (timestamp) => {
  if (!timestamp) return '';
  try {
    const date =
      timestamp.seconds && timestamp.nanoseconds
        ? new Date(timestamp.seconds * 1000)
        : new Date(timestamp);

    const result = formatDistanceToNowStrict(date); // Example: "2 hours"

    const [value, unitRaw] = result.split(' ');

    // Remove plural "s" if present
    const unit = unitRaw.replace(/s$/, '');

    const shortUnits = {
      second: 's',
      minute: 'm',
      hour: 'h',
      day: 'd',
      month: 'mo',
      year: 'y',
    };

    const short = shortUnits[unit] || unit;

    return `${value}${short} ago`;
  } catch (e) {
    console.error('Invalid timestamp:', timestamp, e);
    return '';
  }
};